"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slateNodesToSearchString = void 0;
function slateNodeToStringArray(node, emailsToNames) {
    var _a;
    if (node.text) {
        return [node.text];
    }
    else if (node.type === 'mention' && emailsToNames[node.email]) {
        return [`@${emailsToNames[node.email]}`];
    }
    else {
        const childText = [];
        (_a = node.children) === null || _a === void 0 ? void 0 : _a.forEach((element) => {
            slateNodeToStringArray(element, emailsToNames).forEach((t) => childText.push(t));
        });
        // Paragraphs should just have all their formated text concated
        // All other block types need newlines
        if (node.type === 'paragraph') {
            return [childText.join('')];
        }
        else {
            return childText;
        }
    }
}
function slateNodesToSearchString(nodes, mentions = []) {
    // Accumulate a map from emails to names
    const emailsToNames = mentions.reduce((acc, m) => {
        if (m.email && m.name)
            acc[m.email] = m.name;
        return acc;
    }, {});
    const output = [];
    nodes.forEach((n) => {
        slateNodeToStringArray(n, emailsToNames).forEach((t) => {
            output.push(t);
        });
    });
    return output.join('\n');
}
exports.slateNodesToSearchString = slateNodesToSearchString;
//# sourceMappingURL=slateNodesToString.js.map